<script lang="ts">
  import { onMount } from 'svelte';
  import Router from 'svelte-spa-router';
  import routes from './router';
  import { initTheme } from './theme/theme';
  import './theme/theme.css';

  onMount(() => {
    // resolvedTheme（system/light/dark）の変化を <html data-theme> へ反映し続ける
    const unsubscribe = initTheme();
    return unsubscribe;
  });
</script>

<Router {routes} />
